import { Building2, ClipboardList, Download, FileText, LayoutDashboard, LineChart, ListChecks, Map, MapPin, PenLine, Search, Settings, ShieldCheck, UserCog, Users } from "lucide-react";

const RANK = { N: 0, V: 1, C: 1, M: 2 };

export const can = (user, key, level = "V") => (RANK[user?.permissions?.[key]] || 0) >= RANK[level];

export const isSystem = (user) => user?.role === "system_admin";

export const isNational = (user) => user?.role === "super_admin" || user?.role === "system_admin";

export const ROLE_LABELS = { system_admin: "Amministrazione di sistema", super_admin: "Super admin", admin_sede: "Admin di sede" };

// path, label, visibility, icon
export const adminMenu = (user) => {
    const items = [
        ["", isNational(user) ? "Panoramica nazionale" : "Panoramica", can(user, "panoramica"), LayoutDashboard],
        ["territori", "Confronto territori", can(user, "territori"), Map],
        ["analisi", "Analisi dettagliata", can(user, "analisi"), Search],
        ["aziende", "Aziende", can(user, "aziende"), Building2],
        ["sedi", "Sedi", can(user, "sedi"), MapPin],
        ["amministratori", "Amministratori di sede", can(user, "amministratori"), Users],
        ["questionario", "Questionario", can(user, "questionario"), ClipboardList],
        ["campi", "Campi di registrazione", can(user, "campi"), FileText],
        ["esporta", "Esporta", !isNational(user) && can(user, "aziende") && can(user, "download", "C"), Download],
        ["analytics", "Analytics", can(user, "analytics"), LineChart],
        ["registro", "Registro accessi", can(user, "registro"), ListChecks],
        ["contenuti", "Contenuti del sito", can(user, "contenuti"), PenLine],
        ["utenti", "Utenti e permessi", isSystem(user), ShieldCheck],
        ["impostazioni", "Impostazioni", isSystem(user), Settings],
        ["account", "Il mio account", true, UserCog],
    ];
    return items.filter((i) => i[2]).map(([path, label, , icon]) => [path, label, icon]);
};
